import { render, staticRenderFns } from "./lifecycleEmissions.vue?vue&type=template&id=674ac859&scoped=true"
import script from "./lifecycleEmissions.vue?vue&type=script&lang=js"
export * from "./lifecycleEmissions.vue?vue&type=script&lang=js"
import style0 from "./lifecycleEmissions.vue?vue&type=style&index=0&id=674ac859&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ac859",
  null
  
)

export default component.exports